



















import Vue from 'vue';
import Cropper from 'cropperjs';
import ImagePreview from './ImagePreview.vue';
import ImageChanged from './ImageChanged';

interface Data {
  cropper: Cropper|null,
  element: HTMLImageElement|null,
  image: File|null,
}

export default Vue.extend({
  components: { ImagePreview },
  props: {
    url: String,
    aspectRatio: Number,
  },
  data(): Data {
    return {
      cropper: null,
      element: null,
      image: null,
    };
  },
  computed: {
    isCropping(): boolean {
      return (this.cropper !== null);
    },
  },
  methods: {
    start(element: HTMLImageElement, image: File) {
      if (this.cropper) {
        this.cropper.destroy();
      }
      this.cropper = new Cropper(element, {
        aspectRatio: this.aspectRatio,
        ready: this.crop,
        cropend: this.crop,
        zoom: this.crop,
      });
      this.element = element;
      this.image = image;
    },
    resume() {
      if (this.element && this.image) {
        this.start(this.element, this.image);
      }
    },
    stop() {
      if (this.cropper) {
        this.cropper.destroy();
        this.cropper = null;
      }
    },
    onImageChanged(event: ImageChanged) {
      this.start(event.element, event.image);
    },
    crop() {
      if (this.cropper === null) return;
      const canvas = this.cropper.getCroppedCanvas();
      canvas.toBlob((blob) => {
        if (blob !== null && this.image !== null) {
          this.$emit('cropped', new File([blob], this.image.name));
        }
      });
    },
  },
});
